import React from 'react'

import { 
    useFormContext 
} from "react-hook-form"

import {
    ErrorText
} from '../../../Styles/BaseStyles'

import { 
    SectionDiv, 
    HeaderDiv, 
    FormDiv, 
    SectionHeader, 
    ApplicationRowDiv,
    FullApplicationDiv,
    ApplicationHeader,
    BodyTextArea
} from  '../../../Styles/Components/ApplicationSectionStyles'

// Redux selector

import { useSelector } from "react-redux";

function SkillsSection(props) {

    const { register, errors } = useFormContext()

    const locked = useSelector(state => state.appViewer.locked)

    return (
        <SectionDiv id = {props.name}>
            <HeaderDiv>
                <SectionHeader>Skills</SectionHeader>
            </HeaderDiv>
            <FormDiv>
                <ApplicationRowDiv>
                    <FullApplicationDiv>
                        <ApplicationHeader>Skills List</ApplicationHeader>
                        <BodyTextArea 
                            type="text" name="skills.skills" placeholder="Skills and Areas of Expertise (Separate with commas)" 
                            ref={
                                register({
                                    pattern: {
                                        value: /^[a-zA-Z0-9+#\-() \/\[\]]+\s*(,\s*[a-zA-Z0-9+#\-() \/\[\]]+)*$/,
                                        message: 'invalid format or character usage'
                                    }
                                })
                            } 
                            readOnly={locked}
                        />
                        {errors['skills'] != null && errors['skills']['skills'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['skills']['skills']['message']}</ErrorText>}
                    </FullApplicationDiv>
                </ApplicationRowDiv>
            </FormDiv>
        </SectionDiv>
    )
}

export default SkillsSection;